var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKitchenetteLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "40px",
    viewBox: "0 0 35 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A59CCAD0-5C4C-4EDC-9B55-06AF75E81565") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HOTEL-DETAILS-2",
    transform: "translate(-130.000000, -1892.000000)",
    fill: "#7CBEEA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(10.250000, 111.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(106.750000, 1236.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(13.000000, 540.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kitchenette-light",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,2.5 C4.7421875,2.5 2.5,4.7421875 2.5,7.5 L2.5,12.5 L32.5,12.5 L32.5,7.5 C32.5,4.7421875 30.2578125,2.5 27.5,2.5 L7.5,2.5 Z M2.5,15 L2.5,35 C2.5,36.3828125 3.6171875,37.5 5,37.5 L30,37.5 C31.3828125,37.5 32.5,36.3828125 32.5,35 L32.5,15 L2.5,15 Z M0,7.5 C0,3.359375 3.359375,0 7.5,0 L27.5,0 C31.640625,0 35,3.359375 35,7.5 L35,35 C35,37.7578125 32.7578125,40 30,40 L5,40 C2.2421875,40 0,37.7578125 0,35 L0,7.5 Z M8.125,6.25 C9.16053391,6.25 10,7.08946609 10,8.125 C10,9.16053391 9.16053391,10 8.125,10 C7.08946609,10 6.25,9.16053391 6.25,8.125 C6.25,7.08946609 7.08946609,6.25 8.125,6.25 Z M12.5,8.125 C12.5,7.08946609 13.3394661,6.25 14.375,6.25 C15.4105339,6.25 16.25,7.08946609 16.25,8.125 C16.25,9.16053391 15.4105339,10 14.375,10 C13.3394661,10 12.5,9.16053391 12.5,8.125 Z M20.625,6.25 C21.6605339,6.25 22.5,7.08946609 22.5,8.125 C22.5,9.16053391 21.6605339,10 20.625,10 C19.5894661,10 18.75,9.16053391 18.75,8.125 C18.75,7.08946609 19.5894661,6.25 20.625,6.25 Z M25,8.125 C25,7.08946609 25.8394661,6.25 26.875,6.25 C27.9105339,6.25 28.75,7.08946609 28.75,8.125 C28.75,9.16053391 27.9105339,10 26.875,10 C25.8394661,10 25,9.16053391 25,8.125 Z M7.5,20 L7.5,32.5 L27.5,32.5 L27.5,20 L7.5,20 Z M5,20 C5,18.6171875 6.1171875,17.5 7.5,17.5 L27.5,17.5 C28.8828125,17.5 30,18.6171875 30,20 L30,32.5 C30,33.8828125 28.8828125,35 27.5,35 L7.5,35 C6.1171875,35 5,33.8828125 5,32.5 L5,20 Z M10,23.75 C10,23.0625 10.5625,22.5 11.25,22.5 L23.75,22.5 C24.4375,22.5 25,23.0625 25,23.75 C25,24.4375 24.4375,25 23.75,25 L11.25,25 C10.5625,25 10,24.4375 10,23.75 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchenetteLight);
export default __webpack_public_path__ + "static/media/kitchenette-light.919d8668fc6e73503bb7ce27cc12911c.svg";
export { ForwardRef as ReactComponent };